<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" />
			<span>课程简介</span><i class="el-icon-arrow-right"></i>&nbsp;<span>课程详情</span>
		</div>
		<div class="content">
			<div class="info-content info-content-nobor">
				<div class="info-videocont">
					<div class="info-videoleft">
						<div class="info-videotop">
							<div class="info-videotopp1">
								{{course.name}}
								<div class="info-videoplayinfo">
									<span>正在学习：</span>
									<marquee> {{sectionName}}</marquee>
								</div>
							</div>
							<div class="info-videotopp2">
								制作人：{{course.username}}
								<span class="content-coursestep">|</span> 课程类型：{{course.type}}
								<span class="content-coursestep">|</span> 学习人数：{{addCount() || '0'}}
							</div>
						</div>
						<div class="info-videobottom">
							<div class="info-videobottom-all beautifulScroll" id="showEditor"></div>
						</div>
					</div>
					<div class="info-videoright">
						<div :class="teacherall?'info-videoteacher active':'info-videoteacher'">
							<div class="info-teacherinfo">
								<div class="info-teacherimg"><img src="@/images/1.png" /></div>
								<div class="info-teachername">制作人：{{course.username}}</div>
								<div class="info-teachershow" v-if="course.info" @click="teacherall = !teacherall">
									展开&nbsp;
									<i class="el-icon-arrow-right"></i>
								</div>
							</div>
							<div class="info-teacherdesc hiddenScroll">
								<div style="height: 10px;"></div>
								<span style="font-size: 16px;line-height: 30px;">课程介绍：</span>
								<div v-html="getInfoText(course.info)" style="margin: 0 0 15px 0;"></div>
								<span style="font-size: 16px;line-height: 30px;">参考资料：</span>
								<div v-html="getInfoText(course.references)" style="margin: 0 0 15px 0;"></div>
								<span style="font-size: 16px;line-height: 30px;">课程概述：</span>
								<div v-html="course.overview" class="course_overview" style="margin: 0 0 15px 0;"></div>
							</div>
						</div>
						<div :class="teacherall?'info-videoother active':'info-videoother'">
							<div class="info-othertypes">
								<div :class="typeindex==index?'info-othertype active':'info-othertype'" @click="typeindex = index" v-for="(item,index) in othertypes">
									<img src="@/images/coursenav.png" />
									<span>
										{{item}}
									</span>
								</div>
							</div>
							<div class="info-othercont hiddenScroll" v-show="typeindex==0">
								<div class="info-videolist treeBoxStuLine">
									<el-tree :data="courseTree" :default-expand-all='true' :expand-on-click-node='false' node-key="courseDetailId" :props="defaultProps" @node-click='handleNodeClickStu' ref='courseStudentTree'>
										<div class="custom-tree-node" slot-scope="{ node, data }">
											<div class="asideInfoLabel">
												{{data.courseDetailName}}
											</div>
										</div>
									</el-tree>
								</div>
							</div>
							<div class="info-othercont info-othertalk" v-show="typeindex==1">
								<div class="info-talklist beautifulScroll " id="sectionmain" ref='sectionmain'>
									<div class="oneliveCommont" v-for='(item,index) in hisMessageList'>
										<div class="oneliveinfo" :class="{ 'oneliveinfo_right': item.mine }" v-if="item.label == 'info'">
											<div class="onelivepic">
												<img :src="item.avatar" v-if="item.avatar" />
												<img src="@/images/1.png" v-if="!item.avatar" />
											</div>
											<div class="onelivereal ">
												<div class="liveusernamebox">
													<div class="liveusername">
														<span>{{ item.username }}</span>
													</div>
												</div>
												<div class="massagetext">
													<!--{{item.content}}-->
													<pre v-html="item.content" @click="openImageProxy($event)"></pre>
												</div>
											</div>
										</div>
										<span class="info-talker-cancel" v-if="item.label == 'cancel' && item.muteTime<=0">全体取消禁言</span>
										<span class="info-talker-cancel" v-if="item.label == 'cancel' && item.muteTime>0">全体禁言</span>
									</div>
									<span class="info-talker-cancel" v-if="hisMessageList && hisMessageList.length>0">以上是历史消息</span>
									<div class="oneliveCommont" v-for='(item,index) in messageList'>
										<div class="oneliveinfo" :class="{ 'oneliveinfo_right': item.mine }" v-if="item.label == 'info'">
											<div class="onelivepic">
												<img :src="item.avatar" v-if="item.avatar" />
												<img src="@/images/1.png" v-if="!item.avatar" />
											</div>
											<div class="onelivereal ">
												<div class="liveusernamebox">
													<div class="liveusername">
														<span>{{ item.username }}</span>
													</div>
												</div>
												<div class="massagetext">
													<pre v-html="item.content" @click="openImageProxy($event)"></pre>
												</div>
											</div>
										</div>
										<span class="info-talker-cancel" v-if="item.label == 'cancel' && item.muteTime<=0">全体取消禁言</span>
										<span class="info-talker-cancel" v-if="item.label == 'cancel' && item.muteTime>0">全体禁言</span>
									</div>
								</div>
								<div class="info-talkpublic " :class="chat.master==chatUser.id?'cancel info-talkimg':'info-talkimg'">
									<div class="cancleButton" v-if="!currentChat.unMessageFlag" @click="cancelMessage">
										全体禁言
									</div>
									<div class="cancleButton" v-if="currentChat.unMessageFlag" @click="deleteMessage">
										取消禁言
									</div>
									<el-input :disabled='currentChat.unMessageFlag && chat.master!=chatUser.id' :placeholder="currentChat.unMessageFlag && chat.master!=chatUser.id?'全员禁言中':'请输入内容'" v-model='messageContent' @keyup.enter.native="checkMessage">
										<el-button slot="append" style='color: #FFF;background-color: #409EFF;border-color: #409EFF;' class="info-publicbtn" @click='checkMessage'>发送</el-button>
									</el-input>
									<div class="uploadimg" @click="openupload" v-show="!currentChat.unMessageFlag || chat.master==chatUser.id">
										<i class="el-icon-picture-outline"></i>
										<input type="file" accept=".jpg, .png, .JPG, .PNG" style="display: none;" id="talkImg" ref='talkImg' @change="handleOssPut($event)" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="clearfix">
					<div class="zy_course_studys zy_course_studysbig">
						<div class="course_info_menu ">
							<img src="@/images/courseinfotop.png" class="course_info_menuback" />
							<div class="course_info_menus clearfix">
								<div class="course_info_menuitem" :class="showindex==1?'active':''" @click="showindex = 1">
									<img src="@/images/coursenav.png" />
									<span>课程讨论</span>
								</div>
								<div class="course_info_menuitem" :class="showindex==2?'active':''" @click="showindex = 2" v-if="false">
									<img src="@/images/coursenav.png" />
									<span>课程考核</span>
								</div>
								<div class="course_info_menuitem" :class="showindex==3?'active':''" @click="showindex = 3">
									<img src="@/images/coursenav.png" />
									<span>课程作业</span>
								</div>
								<div class="course_info_menuitem" :class="showindex==4?'active':''" @click="showindex = 4">
									<img src="@/images/coursenav.png" />
									<span>课程测验</span>
								</div>
								<div class="course_info_menuitem" :class="showindex==5?'active':''" @click="showindex = 5">
									<img src="@/images/coursenav.png" />
									<span>课程笔记</span>
								</div>
								<div class="course_info_menuitem" :class="showindex==7?'active':''" @click="showindex = 7">
									<img src="@/images/coursenav.png" />
									<span>教师团队</span>
								</div>
								<div class="course_info_menuitem" :class="showindex==8?'active':''" @click="showindex = 8">
									<img src="@/images/coursenav.png" />
									<span>教学成果</span>
								</div>
							</div>
						</div>
						<div v-show='showindex == 1'>
							<div class="info-replylist">
								<div class="info-listhead">
									<div class="l">讨论列表</div>
									<div class="r" v-show='false'>课程综合评分：<span class="info-listnum">9.8</span>分</div>
									<div class="r">
										<el-button type="success" size='small' @click="commont = true">立即发表</el-button>
									</div>
								</div>
								<div class="noinfo" v-if='commontList.length==0'><i class="el-icon-warning-outline"></i> 还没有人发表哦 ，快去发布吧</div>
								<div class="info-listitem" v-for='(item,index) in commontList'>
									<div class="info-userhead">
										<div class="info-listavatar">
											<img :src="baseurl + item.iconFile" v-if="item.iconFile" />
											<img src="@/images/stu.png" v-else/>
										</div>
										<div class="info-listname clearfix">
											<div class="info-replyinline">
												{{item.realname}}
											</div>
											<div class="info-replyinline" v-show="false">
												<el-rate v-model="videostar" disabled></el-rate>
											</div>
										</div>
										<div class="info-listinfo">
											<span class="r" @click='changeReply(item,index)'>回复</span>
										</div>
									</div>
									<div class="info-listcommont">
										<div>
											{{item.content}}
										</div>
										<div class="info-replys" v-if="item.replies && item.replies.length>0">
											<div v-for="(reply,replyindex) in item.replies" class="info-replyitem" v-if='replyindex<=2'>
												<span class="info-replysname" @click="changeReReply(item,index,reply,1)">{{reply.userName}}</span>&nbsp;回复&nbsp;<span class="info-replysname" @click="changeReReply(item,index,reply,2)">{{reply.replyToName}}</span>：{{reply.content}}
											</div>
											<div v-for="(reply,replyindex) in item.replies" class="info-replyitem" v-if='replyindex>2' v-show="item.show">
												<span class="info-replysname" @click="changeReReply(item,index,reply,1)">{{reply.userName}}</span>&nbsp;回复&nbsp;<span class="info-replysname" @click="changeReReply(item,index,reply,2)">{{reply.replyToName}}</span>：{{reply.content}}
											</div>
											<div class="showmore" @click='showmore(item,index)' v-show="!item.show" v-if='item.replyCount > 3'>显示更多</div>
											<div class="showmore" @click='hidemore(item,index)' v-show="item.show">收起</div>
										</div>
										<div class="info-listtime">
											<span :class="item.isLiked?'static-item like active l':'static-item like l'" @click='changelike(item,index)'>{{item.likeCount}} {{item.isLiked?'已赞':'赞'}}</span>
											<span class="l">{{sectionName}}</span>
											<span class="r">{{item.updateTime |formatTime}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-show='showindex == 2'>
							<div class="info-replyinput">
								<div class="info-replybody ">
									<el-table :data="examineList" stripe style="width: 100%">
										<el-table-column prop="examineName" label="考核名称">
										</el-table-column>
										<el-table-column prop="date" label="考核时间" align="center">
											<template slot-scope="scope">
												{{scope.row.beginTime | spliceForHalfData}} 至 {{scope.row.endTime | spliceForHalfData}}
											</template>
										</el-table-column>
										<el-table-column prop="totalScore" label="考核总分" width='100' align="center">
										</el-table-column>
										<el-table-column prop="passScore" label="我的分数" width='100' align="center">
										</el-table-column>
										<el-table-column label="操作" width='200' align="center">
											<template slot-scope="scope">
												<el-button v-if='scope.row.state == 0' size="mini" type="primary" @click="startexamine(scope.row)">进入考核</el-button>
												<el-button v-if='scope.row.state == 1' size="mini" type="primary" @click="startexamine(scope.row)">进入考核</el-button>
												<el-button v-if='scope.row.state == 2' size="mini" type="primary" @click="examineit(scope.row)">查看结果</el-button>
											</template>
										</el-table-column>
									</el-table>
									<div class="content-coursefoot">
										<el-pagination background @current-change="examinePageChange" :current-page="examinePage" :page-size="pageSize" layout=" prev, pager, next, jumper" :total="examinetotalRow">
										</el-pagination>
									</div>
								</div>
							</div>
						</div>
						<div v-show='showindex == 3'>
							<div class="info-replyinput">
								<div class="info-replybody ">
									<el-table :data="taskList" stripe style="width: 100%">
										<el-table-column prop="name" label="作业名称">
											<template slot-scope="scope">
												<span style="color: red;margin: 0 5px 0 0 ;" v-show='getNew(scope.row)'>[新]</span>{{scope.row.name}}
											</template>
										</el-table-column>
										<el-table-column label="创建时间" align="center">
											<template slot-scope="scope">
												{{scope.row.createTime | spliceForTask}}
											</template>
										</el-table-column>
										<el-table-column prop="createUsername" label="发布人" width='100' align="center">
										</el-table-column>
										<el-table-column prop="topicNum" label="题目数量" width='100' align="center">
										</el-table-column>
										<el-table-column prop="sumScore" label="总分" width='100' align="center">
										</el-table-column>
										<el-table-column prop="passScore" label="及格分" width='100' align="center">
					</el-table-column>
										<el-table-column label="操作" width='150' align="center">
											<template slot-scope="scope">
												<el-button size="mini" type="primary" @click="start(scope.row.id)" v-if='!scope.row.isFinish'>进入作业</el-button>
												<el-button size="mini" type="primary" @click="info(scope.row.id)" v-if='scope.row.isFinish'>查看结果</el-button>
											</template>
										</el-table-column>
									</el-table>
									<div class="content-coursefoot">
										<el-pagination background @current-change="taskPageChange" :current-page="taskPage" :page-size="pageSize" layout="  prev, pager, next, jumper" :total="tasktotalRow">
										</el-pagination>
									</div>
								</div>
							</div>
						</div>
						<div v-show='showindex == 4'>
							<div class="info-replyinput">
								<div class="info-replybody ">
									<div class="info-listhead">
										<div class="l">课程测验</div>
										<div class="r">
											<el-button type="success" size='small' @click='test = true'>组建试题</el-button>
										</div>
									</div>
									<el-table :data="testList" stripe style="width: 100%">
										<el-table-column label="课程" align="center">
											<template slot-scope="scope">
												{{course.name}}
											</template>
										</el-table-column>
										<el-table-column label="创建时间" align="center">
											<template slot-scope="scope">
												{{scope.row.createTime | spliceForHalfData}}
											</template>
										</el-table-column>
										<el-table-column label="课程分类" width='100' align="center">
											<template slot-scope="scope">
												<span v-for='(type,typeindex) in  typeList' v-if='type.value == scope.row.courseType'>
											{{type.name}}
										</span>
											</template>
										</el-table-column>
										<el-table-column label="操作" width='150' align="center">
											<template slot-scope="scope">
												<el-button size="mini" type="primary" @click="testit(scope.row.id)" v-if='scope.row.submit != "1"'>进入测验</el-button>
												<el-button size="mini" type="primary" @click="testitinfo(scope.row.id)" v-if='scope.row.submit == "1"'>查看测验</el-button>
											</template>
										</el-table-column>
									</el-table>
									<div class="content-coursefoot">
										<el-pagination background @current-change="testPageChange" :current-page="testPage" :page-size="pageSize" layout="  prev, pager, next, jumper" :total="testtotalRow">
										</el-pagination>
									</div>
								</div>
							</div>
						</div>
						<div v-show='showindex == 5'>
							<div class="info-replylist">
								<div class="info-listhead">
									<div class="l">笔记列表</div>
									<div class="r">
										<el-button type="success" size='small' @click="opennote">发表笔记</el-button>
									</div>
								</div>
								<div class="noinfo" v-if='noteList.length==0'><i class="el-icon-warning-outline"></i> 还没有人发表笔记哦 ，快去发布吧</div>
								<div class="info-listitem" v-for='(item,index) in noteList'>
									<div class="info-userhead">
										<div class="info-listavatar">
											<img :src="baseurl + item.iconFile" v-if="item.iconFile" />
											<img src="@/images/stu.png" v-else/>
										</div>
										<div class="info-listname clearfix">
											<div class="info-replyinline">
												{{item.realname}}
											</div>
											<div class="info-replyinline" v-show="false">
												<el-rate v-model="videostar" disabled></el-rate>
											</div>
										</div>
										<div class="info-listinfo">
										</div>
									</div>
									<div class="info-listcommont">
										<div v-html='item.content'></div>
										<div class="info-listtime">
											<span class="l">{{sectionName}}</span>
											<span class="r">{{item.updateTime |formatTime}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="clearfix" v-show="showindex==7">
							<div v-if='!courseTeachers || courseTeachers.length==0'>
								<div class="course_quescon">
									<div class="zy_course_wrap clearfix">
										<div class="noinfo"><i class="el-icon-warning-outline"></i> 暂无介绍</div>
									</div>
								</div>
							</div>
							<div class="teacher_team">
								<div class="teacher_teamitem" :class="index%2 == 0?'left':'right'" v-for='(item,index) in courseTeachers'>
									<div class="teacher_teamicon">
										<img :src="baseurl + item.iconurl" v-if="item.iconurl" />
										<img src="@/images/teacher.jpeg" v-else />
									</div>
									<div class="teacher_teaminfo">
										<div class="teacher_teaminfoP1">{{item.name}} - {{item.type}}</div>
										<div class="teacher_teaminfoP2">{{item.title}}</div>
										<div class="teacher_teaminfoP3">{{item.introduce?item.introduce:'暂无介绍'}}</div>
									</div>
								</div>
							</div>
							<div class="content-coursefoot">
										<el-pagination background @current-change="teacherPageChange" :current-page="teachersPage" :page-size="teachersPageSize" layout="  prev, pager, next" :total="teacherstotalRow">
										</el-pagination>
									</div>
						</div>
						<div class="clearfix" v-show="showindex==8">
							<div class="course-description zy_course_wrap">
								<div class="course_overview course_overview_limit" v-if="course.achievements">
									<div class="ql-show-editor" v-html="course.achievements"></div>
								</div>
								<div class="course_quescon" v-else>
									<div class="zy_course_wrap clearfix">
										<div class="noinfo"><i class="el-icon-warning-outline"></i> 暂无信息</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="我的评价" :visible.sync="commont" width="200">
			<el-input type="textarea" resize="none" :rows="6" placeholder="请输入内容" v-model="commontinfo">
			</el-input>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="commontChapters" :disabled='dataloading'>确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="回复" :visible.sync="reply" width="200">
			<el-input type="textarea" :autosize="{ minRows:4, maxRows: 8}" resize='none' :placeholder="replyPlaceholder" v-model="replyContent">
			</el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click="reply = false">取 消</el-button>
				<el-button type="primary" @click="replycreate">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="组建试题" :visible.sync="test" width="280px">
			<el-form ref="form" :model="testform" label-width="80px">
				<el-form-item label="试题个数">
					<el-input v-model="testform.topicAmount" style='width: 100px;'></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="test = false">取 消</el-button>
				<el-button type="primary" @click="testcreate">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="我的笔记" :visible.sync="note" :append-to-body='true' width="200">
			<div class="articleContent">
				<div id="toolbar">
					<button class="ql-bold"></button>
					<button class="ql-italic"></button>
					<button class="ql-image"></button>
					<select class="ql-align">
						<option value="justify" selected></option>
						<option value="center"></option>
						<option value="right"></option>
					</select>
				</div>
				<quill-editor class="editor" ref="myQuillEditor" :content="content" @change="onEditorChange($event)" :options="editorOption">
				</quill-editor>
				<div class="uploadBox" v-show="false">
					<div class="uploadList">
						<el-upload :action="action" :with-credentials='true' :on-success='uploadsuccess' :file-list="fileList" :multiple='false' name='file' accept='image/*' :show-file-list='false' :http-request="formRequest">
							<div class="uploadbtninner">
								<i class="el-icon-plus"></i>
							</div>
						</el-upload>
						<div style="clear: both;"></div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="noteChapters" :disabled='dataloading'>确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="课堂试题" class='videoask' :visible.sync="fileAskShow" :append-to-body='true' width="600px" :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false'>
			<div style="max-height: 500px;overflow-y: auto;">
				<ask v-if='fileAskShow' :qusetionlist='qusetionlist' :questionindex='fileAskIndex' @skipAsk='skipAsk' @closeAsk='closeAsk' @relookAsk='relookAsk'></ask>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getStorageToken, setToken, setStorageToken, removeToken, removeStorageToken, getUserSigLocal } from '@/utils/auth'
	import { getUserById, getInfo } from '@/api/user.js'
	import { getDictByCode } from '@/api/dict.js'
	import { tasklist } from '@/api/task.js'
	import { getLoginUserExamList } from '@/api/examine.js'
	import { testlist, testGen } from '@/api/test.js'
	import { getTeamIntroductionByCourseId, watermarkList, getCourseDetailById, selectCourseDetail, courseRecommend, appCourseTree, sign, unSign, getListByFileId } from '@/api/course.js'
	import { sectionupdate, sectionlist } from '@/api/section.js'
	import { getUserSig, listMuted } from '@/api/chat.js'
	import { commentList, commentLike, commentCancelLikes, commentPublish, replyPublish, replyService } from '@/api/comment.js'
	import { mynoteList, notePublish } from '@/api/note.js'
	import { putProgress } from "@/utils/oss.js";
	import ask from '@/views/courses/ask.vue'
	import conf from "@/utils/im/index";
	import RequestUtils from "@/utils/im/RequestUtils";
	import StoreUtils from "@/utils/im/StoreUtils";
	import { MessageTargetType } from "@/utils/im/ChatUtils";
	import { imageLoad, transform, ChatListUtils } from "@/utils/im/ChatUtils";
	export default {
		name: 'coursedetail',
		components: {
			ask
		},
		computed: {
			messageList: {
				get: function() {
					return this.$store.state.im.messageList;
				},
				set: function(messageList) {
					this.$store.commit("setMessageList", messageList);
				}
			},
			currentChat: {
				get: function() {
					return this.$store.state.im.currentChat;
				},
				set: function(currentChat) {
					this.$store.commit(
						"setCurrentChat",
						JSON.parse(JSON.stringify(currentChat))
					);
				}
			},
			chatList: {
				get: function() {
					return this.$store.state.im.chatList;
				},
				set: function(chatList) {
					this.$store.commit("setChatList", chatList);
				}
			},
			chatUser: {
				get: function() {
					return this.$store.state.im.user;
				},
				set: function(chatList) {
					this.$store.commit("setUser", chatUser);
				}
			}
		},
		data() {
			return {
				courseId: this.$route.query.courseId,
				courses: [''],
				course: {},
				courseTree: [],
				openInfo: {},
				sectionId: this.$route.query.sectionId,
				sectionName: null,
				fileId: null,
				teacherall: false,
				typeindex: 0,
				othertypes: ['课程目录', '在线交流'],
				showindex: 1,
				chepteropen: 0,
				defaultProps: {
					id: 'courseDetailId',
					children: 'childrenList',
					label: 'courseDetailName'
				},
				//常规
				pageSize: 20,
				typeList: [],
				topictype: [],
				dataloading: false,
				//教师
				courseTeachers: [],
				teachersPage: 1,
				teachersPageSize: 5,
				teacherstotalRow: 0,
				//考核
				examinePage: 1,
				examinetotalRow: 0,
				examineList: [],
				//作业
				taskPage: 1,
				tasktotalRow: 0,
				taskList: [],
				//测试
				testPage: 1,
				testtotalRow: 0,
				testList: [],
				test: false,
				testform: {
					topicAmount: 0,
				},
				//笔记
				note: false,
				firstnote: true,
				content: '',
				description: '',
				notePage: 1,
				notegetAll: false,
				cangetnote: true,
				noteList: [],
				//视频
				maxSecond: 0,
				basePdfapi: '',
				play_url: '',
				playType: '',
				viewopen: window.config.VUE_PDF_FILE,
				poster: '',
				watermarkUrl: null,

				fileAskShow: false,
				fileAskIndex: -1,
				qusetionlist: [],
				fileAskTime: [],
				//评论
				videostar: 5,
				commontPage: 1,
				commontgetAll: false,
				cangetcommont: true,
				commontList: [],
				commont: false,
				commontinfo: '',
				//回复
				reply: false,
				commentId: "",
				replyContent: "",
				replyTo: "",
				replyIndex: -1,
				replyPlaceholder: '请输入内容',
				//聊天
				userId: '',
				userinfo: null,
				//聊天
				imgmodal: false,
				imgview: '',
				chatId: '',
				chat: {
					'unMessageFlag': true,
				},
				pageNo: 1,
				count: -1,
				host: window.config.VUE_IM_API,
				messageContent: "",
				userList: [],
				hisMessageList: [],

				//富文本
				fileList: [],
				filesreview: [],
				action: '',
				editorOption: {
					modules: {
						toolbar: '#toolbar',
					},
					placeholder: '请输入正文',
				},
				//推荐
				cangetcr: true,
				crpageSize: 5,
				crpage: 1,
				crList: [],
				crtime: 1,

			}
		},
		created() {
			var token = getStorageToken();
			if(token) {
				this.getMyUserInfo();
			}
			this.getTeamIntroductionByCourseId();
			this.getwatermaker();
			this.getDictTypeList();
			this.getTopicTypeList();
		},
		mounted() {
			this.scrollBottom();
		},
		watch: {

		},
		methods: {
			addCount(){
				var item = this.course;
				var signCount =0
				if(item.signCount && !Number.isNaN(signCount)){
					signCount = item.signCount*1
				}
				var addNumber = 800;
				if(item.name == '针灸学' || item.name == '推拿学'){
					addNumber = 2000;
				}else if(item.name == '传统养生功法' || item.name == '保健按摩'){
					addNumber = 900;
				}else if(item.name == '推拿手法' || item.name == '足反射疗法'){
					addNumber = 1000;
				}
				return signCount+addNumber
			},
			teacherPageChange(teachersPage){
				this.teachersPage = teachersPage;
				this.getTeamIntroductionByCourseId()
			},
			getTeamIntroductionByCourseId() {
				var data = {
					courseId: this.courseId,
					pageNum:this.teachersPage,
					pageSize:this.teachersPageSize,
				}
				getTeamIntroductionByCourseId(data).then(res => {
					this.courseTeachers = res.data.list;
					this.teacherstotalRow = res.data.total;
				})
			},
			getwatermaker() {
				watermarkList().then(res => {
					if(res.data && res.data.length > 0) {
						this.watermarkUrl = this.baseurl + res.data[0].url;
					}
				})
			},
			getNew(item) {
				if(item.beginTime && item.endTime) {
					var nowTime = new Date();
					var beginTime = new Date(item.beginTime.split('T').join(' '));
					var endTime = new Date(item.endTime.split('T').join(' '));
					if(nowTime < beginTime) {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			},
			openupload() {
				this.$refs.talkImg.click();
			},
			handleOssPut(event) {
				const files = event.target.files;
				if(!files || files.length <= 0) {
					return;
				}
				const file = files[0];
				var userId = this.userinfo.userId;
				const key = `cdzy/talkimg/${userId}/${file.name}`;
				putProgress(key, file).then(res => {
					this.messageContent = "img[" + this.baseurl + key + "]";
					this.checkMessage()
					this.$refs.talkImg.value = '';
				});
			},
			getInfoText(strOld) {
				var strNew = ''
				if(strOld) {
					strNew = strOld.replace(/[\r\n]/g, "<br/>");
				}
				return strNew
			},
			getDictTypeList() {
				getDictByCode({
					code: 'course_type',
				}).then(async res => {
					this.typeList = res.data;
				})
			},
			getTopicTypeList() {
				getDictByCode({
					code: 'topic_type',
				}).then(async res => {
					this.topictype = res.data;
				})
			},
			getCourseRecommend() {
				var crtime = this.crtime;
				$('.change').find('i').css('transform', 'rotate(' + crtime * 360 + 'deg)')
				if(this.cangetcr) {
					this.cangetcr = false
					var page = this.crpage
					var data = {
						id: this.courseId,
						majorId: this.courses[0].majorId,
						pageSize: this.crpageSize,
						page: page,
					}
					courseRecommend(data).then(res => {
						if(res.code == 0) {
							const {
								data
							} = res;
							this.crList = res.data.listData;
							this.cangetcr = true;
							this.crtime++;
							if(res.data.listData.length < this.crpageSize) {
								this.crpage = 1
							} else {
								this.crpage = page + 1;
							}
						}
					})
				}
			},
			getMyUserInfo() {
				getInfo({}).then(res => {
					if(res.code == 'OK') {
						const {
							data
						} = res;
						this.userinfo = data;
						this.userId = data.userId;
						this.cuorsesign();
					}
				})
			},
			cuorsesign() {
				var data = {
					courseId: this.courseId
				}
				sign(data).then(res => {
					this.getCourseList();
				})
			},
			getCourseList() {
				var data = {
					courseId: this.courseId
				}
				selectCourseDetail(data).then(res => {
					if(res.code == 0) {
						var courseTree = res.data;
						if(!this.sectionId && (courseTree.length > 0 && courseTree[0].childrenList && courseTree[0].childrenList.length > 0)) {
							this.sectionId = courseTree[0].childrenList[0].courseDetailId
						}
						this.courseTree = courseTree;
						this.getCourseinfo();
					}
				})
			},
			getCourseinfo() {
				var that = this;
				var data = {
					courseId: this.courseId
				}
				appCourseTree(data).then(res => {
					if(res.code == 0) {
						if(res.data && res.data.length > 0) {
							var course = res.data[0];
							var sectionId = this.sectionId;
							this.courses = res.data;
							this.course = course;
							if(sectionId) {
								this.$nextTick(() => {
									this.$refs.courseStudentTree.setCurrentKey(sectionId);
								})
								this.learn(sectionId);
							}
							if(course.chatGroupId) {
								this.chatId = course.chatGroupId;
								this.init();
							}
						} else {
							this.$message({
								type: 'error',
								message: '未查询到课程信息',
								onClose: function() {
									that.$router.back(-1)
								}
							})
						}
					}
				})
			},
			videoplay() {
				var that = this;
				$('video').on('play', function(e) {
					var sectionId = that.sectionId;
					var oldFileId = that.fileId;
					var fileId = $(this).attr('id');
					if(oldFileId != fileId) {
						$('video').each(function() {
							if($(this).attr('id') != fileId) {
								$(this)[0].pause();
							}
						})
						if(oldFileId != '') {
							setTimeout(function() { //视频暂停需要时间
								var currentTime = window.localStorage.getItem('videoplaying' + oldFileId)
								if(currentTime) {
									that.toUpdaateSection(sectionId, oldFileId, currentTime, 0);
									window.localStorage.removeItem('videoplaying' + oldFileId)
								}
							}, 100)
						}
						that.fileId = fileId;
						that.videobreak();
						that.qusetionlist = [];
						that.fileAskTime = [];
						that.getListByFileId();
					}
				})
				$('video').on('timeupdate', function(e) {
					var sectionId = that.sectionId;
					var fileId = $(this).attr('id');
					var currentTimeOld = window.localStorage.getItem('videoplaying' + fileId);
					currentTimeOld = Number(currentTimeOld);
					var currentTimeNew = $(this)[0].currentTime;
					if(currentTimeNew - that.maxSecond > 1.5) {
						$(this)[0].currentTime = currentTimeOld;
					} else {
						window.localStorage.setItem('videoplaying' + fileId, currentTimeNew);
						if(that.maxSecond <= currentTimeNew) {
							that.maxSecond = currentTimeNew;
							var fileAskTime = that.fileAskTime;
							var videotime = Math.floor(currentTimeNew);
							var fileAskIndex = fileAskTime.indexOf(videotime);
							if(fileAskIndex != -1) {
								$(this)[0].pause();
								that.fileAskIndex = fileAskIndex;
								that.fileAskShow = true;
							}
						}
					}
				})
				$('video').on('ended', function(e) {
					var sectionId = that.sectionId;
					var fileId = $(this).attr('id');
					var currentTime = window.localStorage.getItem('videoplaying' + fileId)
					that.toUpdaateSection(sectionId, fileId, currentTime, 1)
					window.localStorage.removeItem('videoplaying' + fileId)
				})
			},
			videobreak() {
				var fileId = this.fileId;
				var data = {
					courseId: this.courseId,
					sectionId: this.sectionId,
					fileId: fileId,
				}
				sectionlist(data).then(res => {
					if(res.code == 0 && res.data && res.data.length > 0) {
						var maxSecond = res.data[0].maxSecond;
						maxSecond = Number(maxSecond);
						if(maxSecond && !isNaN(maxSecond)) {
							this.maxSecond = maxSecond;
						} else {
							this.maxSecond = 0;
						}
						var currentTime = res.data[0].second;
						currentTime = Number(currentTime);
						if(currentTime > 0) {
							$('video#' + fileId)[0].currentTime = currentTime;
						}
					} else {
						this.maxSecond = 0;
						$('video#' + fileId)[0].currentTime = 0;
					}
				})
			},
			skipAsk() {
				this.fileAskShow = false;
				var index = this.fileAskIndex;
				this.qusetionlist.splice(index, 1);
				this.fileAskTime.splice(index, 1);
				$('video')[0].play();
			},
			closeAsk() {
				this.fileAskShow = false;
				var index = this.fileAskIndex;
				this.qusetionlist.splice(index, 1);
				this.fileAskTime.splice(index, 1);
				$('video')[0].play();
			},
			relookAsk() {
				this.fileAskShow = false;
				var index = this.fileAskIndex;
				$('video')[0].currentTime = this.qusetionlist[index].errorBackTime;
				$('video')[0].play();
			},
			getListByFileId() {
				var data = {
					fileId: this.fileId,
				}
				getListByFileId(data).then(res => {
					if(res.code == 0) {
						var qusetionlist = res.data;
						var fileAskTime = [];
						qusetionlist.map(item => {
							fileAskTime.push(item.pointInTime)
						})
						this.qusetionlist = qusetionlist;
						this.fileAskTime = fileAskTime;
						this.formInit();
					}
				})
			},
			formInit() {
				var qusetionlist = this.qusetionlist;
				qusetionlist.map(item => {
					item.over = false;
					item.overdata = false;
					item.choose = [];
					item.filesurl = '';
					item.filearr = [];
					item.userAnswer = '';
					if(item.topicType == 4 || item.topicType == 5) {
						this.isSubjectiveItem = true;
					}
					if(item.isFile == 1 && item.fileName != null) {
						var files = JSON.parse(item.fileName);
						item.files = files;
						var openfiles = [];
						files.map(item => {
							var openurl = this.baseurl + item.url;
							openfiles.push(openurl)
						})
						item.openfiles = openfiles;
					}
					var answerlist = [];
					if(item.optionA != '' && item.optionA != null) {
						if(item.optionA.indexOf('@') == -1) {
							answerlist[0] = {
								type: '1',
								label: 'A',
								value: item.optionA,
							}
						} else {
							answerlist[0] = {
								type: '2',
								label: 'A',
								value: item.optionA.slice(1),
							}
						}
					}
					if(item.optionB != '' && item.optionB != null) {
						if(item.optionB.indexOf('@') == -1) {
							answerlist[1] = {
								type: '1',
								label: 'B',
								value: item.optionB,
							}
						} else {
							answerlist[1] = {
								type: '2',
								label: 'B',
								value: item.optionB.slice(1),
							}
						}
					}
					if(item.optionC != '' && item.optionC != null) {
						if(item.optionC.indexOf('@') == -1) {
							answerlist[2] = {
								type: '1',
								label: 'C',
								value: item.optionC,
							}
						} else {
							answerlist[2] = {
								type: '2',
								label: 'C',
								value: item.optionC.slice(1),
							}
						}
					}
					if(item.optionD != '' && item.optionD != null) {
						if(item.optionD.indexOf('@') == -1) {
							answerlist[3] = {
								type: '1',
								label: 'D',
								value: item.optionD,
							}
						} else {
							answerlist[3] = {
								type: '2',
								label: 'D',
								value: item.optionD.slice(1),
							}
						}
					}
					if(item.optionE != '' && item.optionE != null) {
						if(item.optionE.indexOf('@') == -1) {
							answerlist[4] = {
								type: '1',
								label: 'E',
								value: item.optionE,
							}
						} else {
							answerlist[4] = {
								type: '2',
								label: 'E',
								value: item.optionE.slice(1),
							}
						}
					}
					if(item.optionF != '' && item.optionF != null) {
						if(item.optionF.indexOf('@') == -1) {
							answerlist[5] = {
								type: '1',
								label: 'F',
								value: item.optionF,
							}
						} else {
							answerlist[5] = {
								type: '2',
								label: 'F',
								value: item.optionF.slice(1),
							}
						}
					}
					item.answerlist = answerlist;
				})
				this.qusetionlist = qusetionlist;
			},
			toUpdaateSection(sectionId, fileId, second, isWatchFinish) {
				var second = parseInt(Number(second));
				var maxSecond = parseInt(this.maxSecond);
				maxSecond = maxSecond<second?second:maxSecond;
				var data = {
					fileId: fileId,
					sectionId: sectionId,
					second: second,
					maxSecond: maxSecond,
				}
				if(isWatchFinish == 1) {
					var duration = $('video#' + fileId)[0].duration;
					if(duration - maxSecond <= 2) {
						data.isWatchFinish = isWatchFinish
					}
				}
				sectionupdate(data)
			},
			toUpdaateSectionFile(sectionId) {
				var data = {
					sectionId: sectionId,
					second: 0,
					maxSecond: 0,
					isWatchFinish: 1,
				}
				sectionupdate(data)
			},
			handleNodeClickStu(data) {
				if(data.parentId == '0') {
					return
				}
				this.$refs.courseStudentTree.setCurrentKey(data.courseDetailId);
				if(this.sectionId != data.courseDetailId) {
					this.learn(data.courseDetailId)
				}
			},
			learn(sectionId) {
				var fileId = this.fileId;
				var oldSection = this.sectionId;
				getCourseDetailById({
					id: sectionId
				}).then(res => {
					var openInfo = res.data;
					this.toUpdaateSectionFile(oldSection);
					if(fileId) {
						var currentTime = window.localStorage.getItem('videoplaying' + fileId)
						if(currentTime) {
							this.toUpdaateSection(oldSection, fileId, currentTime, 0);
							window.localStorage.removeItem('videoplaying' + fileId)
						}
					}
					this.maxSecond = 0;
					this.sectionId = sectionId;
					this.fileId = '';
					this.sectionName = openInfo.courseDetailName;
					this.openInfo = openInfo;
					this.contentAdd(openInfo);
					this.regetAll();
				})
			},
			contentAdd(playItem) {
				this.$nextTick(() => {
					var that = this;
					var content = playItem.content
					if(content && content != '') {
						$('#showEditor').html('')
						content = $(content);
						var add_files = content.find('.add_files');
						if(add_files && add_files.length > 0) {
							content.find('.add_files').each(function(i) {
								var data = $(this).attr('data');
								data = JSON.parse(decodeURIComponent(data));
								if(data.taskPoint == '1') {
									var taskPointEle = '<div class="taskPoint"><div class="taskPointBefore"></div>任务点：' + data.fileName + '</div>'
									content.find('.add_files').eq(i).before($(taskPointEle))
								}
								var playUrl = '';
								var playEle = '';
								var typeInfo = '';
								var typeActive = '';
								var typeText = '展开';
								var watermaker = '';
								if(data.fileType != '0' && data.fileType != '5') {
									playUrl = that.viewopen + encodeURIComponent(window.btoa(that.baseurl + data.fileUrl));
									playEle = '<iframe id="iframePage" src="' + playUrl + '" class="addPush"></iframe>';
								}
								if(data.fileType == '5') {
									playUrl = that.baseurl + data.fileUrl;
									playEle = '<img id="' + data.id + '" src="' + playUrl + '"  class="addPushImg"/>';
								}
								if(data.fileType == '0') {
									playUrl = that.baseurl + data.fileUrl;
									playEle = '<video id="' + data.id + '" height="550" src="' + playUrl + '" poster="' + that.baseurl + that.course.banner + '" controls="controls" controlsList="nodownload" class="addPush"></video>';
								}
								if(data.fileType == '0') {
									typeInfo = '<span class="fileType el-tag el-tag--medium el-tag--light"><i class="iconfont iconshipin1"></i> 视频</span>';
								}
								if(data.fileType == '1') {
									typeInfo = '<span class="fileType el-tag el-tag--success el-tag--medium el-tag--light"><i class="iconfont iconpdf1"></i> PDF</span>';
								}
								if(data.fileType == '2') {
									typeInfo = '<span class="fileType el-tag el-tag--warning el-tag--medium el-tag--light"><i class="iconfont iconppt"></i> PPT</span>';
								}
								if(data.fileType == '3') {
									typeInfo = '<span class="fileType el-tag el-tag--info el-tag--medium el-tag--light"><i class="iconfont iconword"></i> DOC</span>';
								}
								if(data.fileType == '4') {
									typeInfo = '<span class="fileType el-tag el-tag--success el-tag--medium el-tag--light"><i class="iconfont iconXLS"></i> XLS</span>';
								}
								if(data.fileType == '5') {
									typeInfo = '<span class="fileType el-tag el-tag--danger el-tag--medium el-tag--light"><i class="el-icon-link"></i> 图片</span>';
								}
								if(i == 0) {
									typeActive = 'active';
									typeText = '折叠';
								}
								if(that.watermarkUrl) {
									watermaker = '<img src="' + that.watermarkUrl + '" class="course_addBodyWater" />';
								}
								if(data.fileType != '5') {
									playEle = '<div class="course_addBox ' + typeActive + '"><div class="course_addHead">' + typeInfo + data.fileName + '<div class="r course_addShow">' + typeText + '</div></div><div class="course_addBody">' + watermaker + playEle + '</div></div>'
								}
								content.find('.add_files').eq(i).after($(playEle))
							})
						}
						setTimeout(function() {
							$('#showEditor').append(content);
							$('#showEditor').animate({
								scrollTop: 0
							}, 100);
							$('#showEditor').find('.add_files').remove();
							that.videoplay();
							that.bindOpen();
						}, 600)
					} else {
						$('#showEditor').html('<div class="tno-like">暂无内容</div>')
					}
				})
			},
			bindOpen() {
				var that = this;
				this.$nextTick(() => {
					$('.course_addShow').unbind('click');
					$('.course_addShow').bind('click', function() {
						if($(this).parents('.course_addBox').hasClass('active')) {
							$(this).text('展开');
							$(this).parents('.course_addBox').removeClass('active')
						} else {
							$(this).text('折叠');
							$(this).parents('.course_addBox').addClass('active')
						}
					});
				})
			},
			regetAll() {
				//评论
				this.commontgetAll = false;
				this.cangetcommont = true;
				this.commontPage = 1;
				this.commontList = [];
				this.getCommentList();
				//考核
				this.examinePage = 1;
				this.getExamineList();
				//作业
				this.taskPage = 1;
				this.getTaskList();
				//测试
				this.testPage = 1;
				this.getTestList();
				//笔记
				this.notegetAll = false;
				this.cangetnote = true;
				this.notePage = 1;
				this.noteList = [];
				this.getNoteList();
				//推荐课程
				this.crpage = 1;
				this.getCourseRecommend();
			},
			scrollBottom() {
				var that = this;
				$(window).unbind('scroll');
				$(window).on('scroll', function() {
					var scrollTop = window.scrollY;
					var scrollInner = window.innerHeight;
					var scrollHeight = document.body.scrollHeight;
					if(scrollTop + scrollInner + 80 >= scrollHeight) {
						if(that.showindex == 1) {
							that.getCommentList()
						}
						if(that.showindex == 5) {
							that.getNoteList()
						}
					}
					var windowWidth = $(window).width();
					var videoWidth = $('.info-videoleft').width();
					var mainWidth = $('.info-content').width();
					var mainHeight = $('.info-videocont').height();
					var leftWidth = (windowWidth - mainWidth) / 2 + videoWidth;
					if(scrollTop < 250) {
						$('.info-videocont').removeClass('active');
						$('.info-videocont').removeClass('allActive');
						$('.info-videoright').css('left', 'initial')
					}
					if(scrollTop >= 250 && scrollTop <= mainHeight + 250 - scrollInner) {
						$('.info-videocont').addClass('active');
						$('.info-videocont').removeClass('allActive');
						$('.info-videoright').css('left', leftWidth + 'px')
					}
					if(scrollTop > mainHeight + 250 - scrollInner) {
						$('.info-videocont').removeClass('active');
						$('.info-videocont').addClass('allActive');
						$('.info-videoright').css('left', 'initial')
					}
				});
			},
			getCommentList() {
				if(!this.commontgetAll && this.cangetcommont && this.sectionId) {
					this.cangetcommont = false
					var page = this.commontPage
					var data = {
						pageSize: this.pageSize,
						page: page,
						courseId: this.courseId,
						sectionId: this.sectionId,
					}
					commentList(data).then(res => {
						if(res.code == 0) {
							const {
								data
							} = res;
							this.commontList = this.commontList.concat(res.data.listData);
							this.cangetcommont = true;
							this.commontPage = page + 1;
							if(res.data.listData.length < this.pageSize) {
								this.commontgetAll = true
							}
						}
					})
				}
			},
			changelike(item, index) {
				var data = {
					commentId: item.id
				}
				var commontList = this.commontList;
				if(!item.isLiked) {
					commentLike(data).then(res => {
						if(res.code == 0) {
							commontList[index].isLiked = true;
							var likeCount = commontList[index].likeCount * 1 + 1;
							likeCount = likeCount < 0 ? 0 : likeCount
							commontList[index].likeCount = likeCount;
							this.$set(commontList, index, commontList[index]);
						}
					})
				} else {
					commentCancelLikes(data).then(res => {
						if(res) {
							commontList[index].isLiked = false;
							var likeCount = commontList[index].likeCount * 1 - 1;
							likeCount = likeCount < 0 ? 0 : likeCount
							commontList[index].likeCount = likeCount;
							this.$set(commontList, index, commontList[index]);
						}
					})
				}

			},
			commontChapters() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				var commontinfo = this.commontinfo;
				if(commontinfo != '') {
					var data = {
						content: commontinfo,
						sectionId: this.sectionId
					}
					commentPublish(data).then(res => {
						if(res.code == 0) {
							var data = res.data;
							data.realname = this.userinfo.name;
							data.replies = [];
							this.commontList.unshift(data);
							this.commont = false;
							this.commontinfo = '';
							this.$message.success('发布成功')
						} else {
							this.$message.error('发布失败，请稍后重试')
						}
					})
				} else {
					this.$message.error('请输入内容')
				}
			},
			showmore(item, index) {
				var commontList = this.commontList;
				var data = {
					commentId: commontList[index].id,
				}
				replyService(data).then(res => {
					if(res.code == 0) {
						var morereply = res.data.splice(3);
						commontList[index].replies = commontList[index].replies.concat(morereply);
						commontList[index].show = true;
						this.$set(commontList, index, commontList[index])
					}
				})
			},
			hidemore(item, index) {
				var commontList = this.commontList;
				commontList[index].show = false;
				this.$set(commontList, index, commontList[index])
			},
			changeReReply(item, index, reply, type) {
				this.replyIndex = index;
				this.commentId = item.id;
				this.reply = true;
				if(type == 1) {
					this.replyTo = reply.userId;
					this.replyPlaceholder = '回复' + reply.userName + '：';
				}
				if(type == 2) {
					this.replyTo = reply.replyTo;
					this.replyPlaceholder = '回复' + reply.replyToName + '：';
				}
			},
			changeReply(item, index) {
				this.replyIndex = index;
				this.replyTo = item.userId;
				this.commentId = item.id;
				this.replyPlaceholder = '请输入信息';
				this.reply = true;
			},
			closeReply() {
				this.replyIndex = -1;
				this.replyTo = '';
				this.commentId = '';
				this.replyContent = '';
				this.replyPlaceholder = '请输入信息';
				this.reply = false;
			},
			replycreate() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				var replyContent = this.replyContent;
				if(replyContent && replyContent != '') {
					var data = {
						commentId: this.commentId,
						replyTo: this.replyTo,
						content: this.replyContent,
					}
					replyPublish(data).then(res => {
						if(res.code == 0) {
							this.$message({
								title: '提示',
								message: '回复成功',
								type: 'success'
							});
							this.commontList[this.replyIndex].replies.unshift(res.data);
						} else {
							this.$message({
								title: '提示',
								message: '回复失败，请稍后重试',
								type: 'info'
							});
						}
						this.closeReply()
					})
				} else {
					this.$message({
						title: '提示',
						message: '请输入回复内容',
						type: 'info'
					});
				}
			},
			examinePageChange(page) {
				this.examinePage = page;
				this.getExamineList()
			},
			getExamineList() {
				var data = {
					courseId: this.courseId,
					sectionId: this.sectionId,
					page: this.examinePage,
					pageSize: this.pageSize
				}
				getLoginUserExamList(data).then(res => {

					if(res.code == 0 && res.data) {
						var examineList = res.data.listData ? res.data.listData : [];
						this.examineList = examineList;
						this.examinetotalRow = res.data.totalRow;
					}
				})
			},
			startexamine(item) {
				var nowDate = new Date().getTime();
				var beginDate = new Date(item.beginTime).getTime();
				var endDate = new Date(item.endTime).getTime();
				if(nowDate >= beginDate && nowDate < endDate) {
					this.$router.push({
						name: 'examine',
						query: {
							examineId: item.examineId,
							totalScore: item.totalScore,
						}
					})
				}
				if(nowDate < beginDate) {
					this.$message.error('考核未开始！')
				}
				if(nowDate >= endDate) {
					this.$message.error('考核已结束！')
				}
			},
			examineit(item) {
				this.$router.push({
					name: 'myexamine',
					query: {
						recordId: item.id,
						totalScore: item.totalScore,
						passScore: item.passScore,
					}
				})
			},
			taskPageChange(page) {
				this.taskPage = page;
				this.getTaskList()
			},
			getTaskList() {
				var data = {
					courseId: this.courseId,
					sectionId: this.sectionId,
					pageSize: this.pageSize,
					page: this.taskPage
				}
				tasklist(data).then(res => {
					if(res.code == 0) {
						this.tasktotalRow = res.data.totalRow;
						this.taskList = res.data.listData
					}
				})
			},
			testPageChange(page) {
				this.testPage = page;
				this.getTestList()
			},
			getTestList() {
				var data = {
					courseId: this.courseId,
					pageSize: this.pageSize,
					page: this.testPage
				}
				testlist(data).then(res => {
					if(res.code == 0) {
						this.testtotalRow = res.data.totalRow;
						this.testList = res.data.listData
					}
				})
			},
			testcreate() {
				var course = this.courses[0]
				var data = {
					courseId: course.id,
					courseName: course.name,
					courseType: course.majorId,
					courseTypeName: course.type,
				};
				var topicAmount = this.testform.topicAmount;
				topicAmount = Number(topicAmount);
				if(isNaN(topicAmount)) {
					this.$message.error('请输入数字')
				} else if(topicAmount <= 0 || topicAmount % 1 != 0) {
					this.$message.error('请输入大于零的数字')
				} else {
					data.topicAmount = topicAmount;
					testGen(data).then(res => {
						if(res.code == 0) {
							this.test = false
							this.testPage = 1;
							this.getTestList()
						} else {
							this.$message.error(res.message)
						}
					})
				}
			},
			onEditorChange({
				quill,
				html,
				text
			}) {
				this.description = text;
				this.content = html;
			},
			opennote() {
				this.note = true;
				if(this.firstnote) {
					this.firstnote = false
					this.editorUpload();
				}
			},
			editorUpload() {
				var that = this;
				var index = 0
				var timer = setInterval(_ => {
					index++;
					var myQuillEditor = that.$refs.myQuillEditor;
					if(myQuillEditor) {
						clearInterval(timer);
						var imgHandler = async function(image) {
							that.addImgRange = that.$refs.myQuillEditor.quill.getSelection();
							if(image) {
								document.getElementsByClassName('uploadbtninner')[0].click()
							}
						}
						that.$refs.myQuillEditor.quill.getModule("toolbar").addHandler("image", imgHandler);
					} else {
						if(index >= 9) {
							clearInterval(timer);
						}
					}
				}, 300)
			},
			getNoteList() {
				if(!this.notegetAll && this.cangetnote) {
					this.cangetnote = false
					var page = this.notePage
					var data = {
						pageSize: this.pageSize,
						page: page,
						courseId: this.courseId,
						sectionId: this.sectionId,
					}
					mynoteList(data).then(res => {
						if(res.code == 0) {
							const {
								data
							} = res;
							this.noteList = this.noteList.concat(res.data.listData);
							this.cangetnote = true;
							this.notePage = page + 1;
							if(res.data.listData.length < this.pageSize) {
								this.notegetAll = true
							}
						}
					})
				}
			},
			noteChapters() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				var content = this.content;
				if(content != '') {
					var data = {
						content: content,
						sectionId: this.sectionId
					}
					notePublish(data).then(res => {
						if(res.code == 0) {
							var data = res.data;
							data.realname = this.userinfo.name;
							data.iconFile = this.userinfo.iconurl;
							this.noteList.unshift(data);
							this.note = false;
							this.content = '';
							this.description = '';
							this.$message.success('发布成功')
						} else {
							this.$message.error('发布笔记失败，请稍后重试')
						}
					})
				} else {
					this.$message.error('请输入内容')
				}
			},
			get_suffix(filename) {
				let pos = filename.lastIndexOf('.')
				let suffix = ''
				if(pos != -1) {
					suffix = filename.substring(pos)
				}
				return suffix
			},
			formRequest(file) {
				let that = this;
				var dir = 'cdzy/mooc/';
				var noeDate = new Date();
				var year = noeDate.getFullYear();
				var month = noeDate.getMonth() + 1;
				month = month < 10 ? '0' + month : month;
				var day = noeDate.getDate();
				day = day < 10 ? '0' + day : day;
				dir = dir + year + "/" + month + "/" + day + '/';
				const uploadfile = file.file;
				const key = dir + noeDate.getTime() + this.get_suffix(file.file.name);
				putProgress(key, uploadfile, function(progressEvent) {
					let e = {}
					e.percent = progressEvent * 100 || 0;
					file.onProgress(e)
				}).then(res => {
					let e = {
						code: 0,
						success: true,
						message: '',
						data: key
					}
					file.onSuccess(e)
				});
			},
			uploadsuccess(res, file, fileList) {
				var _this = this;
				var baseurl = this.baseurl;
				if(res) {
					var value = baseurl + res.data;
					_this.addImgRange = _this.$refs.myQuillEditor.quill.getSelection()
					_this.$refs.myQuillEditor.quill.insertEmbed(_this.addImgRange != null ? _this.addImgRange.index : 0, 'image', value, null)
				}
				if(res.code == 0) {
					var filesreview = this.filesreview;
					filesreview.push(res.data);
					this.filesreview = filesreview;
					this.fileList = [];
				}
			},
			init() {
				var chatId = this.chatId;
				var chatGroupList = this.$store.state.im.chatGroupList;
				if(chatGroupList && chatGroupList.length > 0) {
					chatGroupList.map(chat => {
						if(chat.id == chatId) {
							var newChat = {
								id: chat.id,
								name: chat.name,
								avatar: chat.avatar,
								master: chat.master,
								unReadCount: chat.unReadCount ? chat.unReadCount : 0,
								unMessageFlag: chat.unMessageFlag ? chat.unMessageFlag : false,
								type: 1,
							}
							this.chat = newChat;
						}
					})
				}
				ChatListUtils.resetChatList(this, this.$store.state.im.user, conf.getHostUrl(), MessageTargetType.CHAT_GROUP);
				this.initIm();
				this.getHistory();
				this.scrollMain();
			},
			initIm() {
				this.$store.commit("resetUnRead");
				this.$store.commit("setCurrentChat", this.chat);
				this.$store.commit("setChatList", ChatListUtils.getChatList(this.$store.state.im.user.id));
				this.messageList = [];
				// 从内存中取聊天信息
				let cacheMessages = this.$store.state.im.messageListMap[this.chat.id];
				if(cacheMessages) {
					this.messageList = cacheMessages;
				}
				let currentChat = this.$store.state.im.currentChat;
				if(currentChat) {
					this.currentChat = currentChat;
				}
				// 每次滚动到最底部
				this.$nextTick(() => {
					imageLoad("sectionmain");
				});
				if(this.chat.type === "1") {
					let param = new FormData();
					param.set("chatId", this.chat.id);
					RequestUtils.getInstance().request(conf.getChatUsersUrl(), param).then(response => {
						return response.json();
					}).then(json => {
						this.userList = json;
					});
				}
			},
			openImageProxy(event) {
				event.preventDefault();
				if(event.target.nodeName === "IMG") {
					this.imgmodal = true;
					this.imgview = event.target.src;
				} else if(event.target.className === "message-file") {
					this.winControl.openURL(event.target.href);
				}
			},
			checkMessage() {
				let currentUser = this.$store.state.im.user;
				let time = new Date().getTime();
				let content = this.messageContent;
				if(content !== "" && content !== "\n") {
					if(content.length > 2000) {
						this.openMessage("不能超过2000个字符");
					} else {
						let currentMessage = {
							mine: true,
							avatar: currentUser.avatar,
							username: currentUser.name,
							timestamp: time,
							content: content,
							fromid: currentUser.id,
							id: this.chat.id,
							type: this.chat.type,
							label: 'info',
						};
						if(content && content.indexOf('!!全体禁言!!-') != -1) {
							var muteTime = content.split('-')[2];
							currentMessage.label = 'cancel'
							currentMessage.muteTime = Number(muteTime);
						}
						this.sendTimMessage(currentMessage);
					}
				}
			},
			cancelMessage() {
				let param = new FormData();
				param.set("chat_id", this.chat.id);
				param.set("state", '1');
				RequestUtils.getInstance().request(conf.getForbiddenUrl(), param).then(response => {
					if(response) {
						let currentUser = this.$store.state.im.user;
						let time = new Date().getTime();
						let content = '!!全体禁言!!-全体-1';
						let currentMessage = {
							mine: true,
							avatar: currentUser.avatar,
							username: currentUser.name,
							timestamp: time,
							content: content,
							fromid: currentUser.id,
							id: this.chat.id,
							type: this.chat.type,
							label: 'cancel',
							muteTime: 1,
						};
						this.sendTimMessage(currentMessage);
						this.chat.unMessageFlag = true;
					}
				})
			},
			deleteMessage() {
				let param = new FormData();
				param.set("chat_id", this.chat.id);
				param.set("state", '0');
				RequestUtils.getInstance().request(conf.getForbiddenUrl(), param).then(response => {
					if(response) {
						let currentUser = this.$store.state.im.user;
						let time = new Date().getTime();
						let content = '!!全体禁言!!-全体-0';
						let currentMessage = {
							mine: true,
							avatar: currentUser.avatar,
							username: currentUser.name,
							timestamp: time,
							content: content,
							fromid: currentUser.id,
							id: this.chat.id,
							type: this.chat.type,
							label: 'cancel',
							muteTime: 0,
						};
						this.sendTimMessage(currentMessage);
						this.chat.unMessageFlag = false;
					}
				})
			},
			sendTimMessage(message) {
				this.$store.commit("sendMessage", message);
				message.timestamp = this.formatDateTime(new Date(message.timestamp));
				this.$store.commit("addMessage", message);
				this.messageContent = "";
				// 每次滚动到最底部
				this.$nextTick(() => {
					imageLoad("sectionmain");
				});
			},
			scrollMain() {
				var that = this;
				$('#sectionmain').scroll(function() {
					var scrollTop = $('#sectionmain')[0].scrollTop;
					if(scrollTop == 0) {
						that.getHistory()
					}
				})
			},
			getHistory() {
				var that = this;
				if(this.hisMessageList.length < this.count || this.count == -1) {
					let param = new FormData();
					param.set("chatId", this.chat.id);
					param.set("chatType", this.chat.type);
					param.set("fromId", this.$store.state.im.user.id);
					param.set("pageNo", this.pageNo);
					RequestUtils.getInstance().request(conf.getHisUrl(), param).then(response => {
						return response.json();
					}).then(json => {
						let list = json.messageList.map(function(element) {
							element.content = transform(element.content);
							return element;
						});
						let tempList = list.map(function(message) {
							message.timestamp = that.formatDateTime(
								new Date(message.timestamp)
							);
							return message;
						});
						that.hisMessageList = tempList.reverse().concat(that.hisMessageList);
						that.count = json.count;
						that.pageNo++;
					});
				}
			},
			start(id) {
				this.$router.push({
					name: 'task',
					query: {
						taskId: id
					}
				})
			},
			info(id) {
				this.$router.push({
					name: 'taskdetails',
					query: {
						taskId: id
					}
				})
			},
			testit(id) {
				this.$router.push({
					name: 'test',
					query: {
						testId: id,
						coursename: this.courses[0].name
					}
				})
			},
			testitinfo(id) {
				this.$router.push({
					name: 'testdetails',
					query: {
						testId: id,
						coursename: this.courses[0].name
					}
				})
			},
			toCoursedetail(id) {
				this.$router.push({
					name: 'courseindex',
					query: {
						courseId: id
					}
				})
			},
			toName(name) {
				if(this.$route.name != name) {
					this.$router.push({
						name
					})
				}
			},
		},
		beforeRouteLeave(to, from, next) {
			this.nextReqMessageID = null; //重新进入页面后重新拉取
			this.historytime = 1;
			var sectionId = this.sectionId;
			var fileId = this.fileId;
			var currentTime = window.localStorage.getItem('videoplaying' + fileId)
			if(currentTime) {
				$('video').unbind('play');
				$('video').unbind('timeupdate');
				$('video').unbind('ended');
				this.toUpdaateSection(sectionId, fileId, currentTime, 0)
				window.localStorage.removeItem('videoplaying' + fileId)
			}
			next();
		},
	}
</script>